import { useUpdateHabitGroupByMutation } from 'shared/hooks/queries/use-update-habit-group-by-mutation';

export const useUpdateHabitGroupBy = () => {
  const { mutate } = useUpdateHabitGroupByMutation();

  return mutate;
};
